<template> 
  <div class="single-upload">
    <el-upload ref="upload" class="upload-demo" action="api/teacher/importExcel" accept=".xls,.xlsx" :before-upload="beforeUpload" :http-request="uploadFile" :multiple="false" :headers="header" v-loading="loading" :on-exceed="handleExceed" :file-list="fileList" :on-remove="handleRemove" :show-file-list="false">
      <el-button type="primary" plain :size="size" class="button">
        <div>
          <span> {{title}}</span>
        </div>

      </el-button>
    </el-upload>
  </div>
</template>
<script>
export default {
  name: 'fileUpload',
  props: {
    title: {
      type: String,
      default: "导入数据",
    },
    use: {
      default: "product"
    },
    sizeLimited: {
      type: Number,
      default: 1
    },

    isShow: {
      default: true
    },
    limit: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
    }
  },
  created() {
  },
  computed: {
    header() {
      return {
        Authorization: localStorage.getItem("token")
      };
    }
  },
  data() {
    return {
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      loading: false
    };
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.$emit("removeUpload", {
        file: file,
        fileList: fileList,
      })
    },
    beforeUpload(file) {
      //判断文件格式
      let hz = file.name.split(".")[1];
      if (hz != "xlsx" && hz != "xls") {
        this.$alert("只能上传EXCEL文件！");
        return false;
      }
    },

    //上传文件
    uploadFile(item) {
      this.$emit("addUpload", {
        file: item.file,
      });
      console.log(this.fileList, "uploadFile")
    },

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      // console.log("handleExceed", files, fileList);
      this.$message({
        message: `最多只能上传${this.limit}个!`,
        type: 'error',
        duration: 1500,
        onClose: () => {
        }
      })
    },

  }
}
</script>
<style lang="scss" scoped>
.button {
  height: 36px !important;
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/FileUpload.vue